import React from "react";
import { Box, Typography } from "@material-ui/core";
import useStyles from "./detailStyles";

export default function DetailRow({ label, icon, children }) {
  const classes = useStyles();
  return <Box className={classes.detailRow}>
    <Typography component="dt" className={classes.detailLabel}>{icon}{label}</Typography>
    <Typography component="dd" className={classes.detailValue}>{children ?? "—"}</Typography>
  </Box>;
}
